"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var kb_tree_leaf_1 = require("./kb-tree-leaf");
var KbTreeNode = /** @class */ (function () {
    function KbTreeNode(nodeName, nodeNameMultilingual) {
        this.nodeName = nodeName;
        this.nodeNameMultilingual = nodeNameMultilingual;
        this.childNodes = [];
        this.childLeafs = [];
    }
    KbTreeNode.prototype.addChildLeaf = function (fieldControllerMeta, toAdd) {
        var newChildLeaf = new kb_tree_leaf_1.KbTreeLeaf(fieldControllerMeta, toAdd);
        this.childLeafs.push(newChildLeaf);
    };
    return KbTreeNode;
}());
exports.KbTreeNode = KbTreeNode;
//# sourceMappingURL=kb-tree-node.js.map